<template>
  <gmap-map
      :center="center"
      :zoom="zoom"
      :options=" {
          styles: StyledMapType,
          streetViewControl: streetViewControl,
          mapTypeControl: false
        }"
    >
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        @click="center=m.position"
        :icon="m.icon"
      ></gmap-marker>
    </gmap-map>
</template>

<script>
  import styledMapTypeJson from './StyledMapType.json'

  export default {
    name: 'ghMap',

    props: {
      position: {
        type: Object,
        required: true
      },
      streetViewControl: {
        type: Boolean,
        default: true
      },
      zoom: {
        type: Number,
        default: 16
      },
      markerIcon: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        center: this.position,
        markers: [{
          position: this.position,
          icon: this.markerIcon
        }]
      };
    },

    computed: {
      StyledMapType () {
        return styledMapTypeJson
      }
    }
  }
</script>

<style scoped lang="sass">

</style>
